import { photoOrientation } from './photoOrientation';

export enum linkProvider {
  youTube = 'YouTube',
  instagram = 'Instagram',
  tiktok = 'TikTok',
  pinterest = 'Pinterest',
}

export type MediaType = 'photo' | 'clip' | 'video' | 'link';

export const getMediaType = (media: any): MediaType => {
  if (media?.media_type) {
    return media.media_type;
  }
  if (media?.type === 'video') {
    return 'video';
  } else if (media?.type === 'clip') {
    return 'clip';
  } else if (media?.type === 'link') {
    return 'link';
  } else {
    return 'photo';
  }
};

export const getOrientation = (media: any, mediaType: string) => {
  if (media === undefined) {
    return 'portrait';
  } else {
    if (mediaType === 'video') {
      return 'landscape';
    } else if (mediaType === 'link') {
      const { provider, width, height } = media;
      const defaultOrientation = provider === linkProvider.youTube ? 'landscape' : 'portrait';
      if (width !== null && height !== null) {
        if (width > height) {
          return 'landscape';
        } else if (width < height) {
          return 'portrait';
        } else {
          return defaultOrientation;
        }
      }
      return defaultOrientation;
    } else if (mediaType === 'clip') {
      return media.orientation;
    } else {
      return photoOrientation(media);
    }
  }
};
